import { createElement, HTMLAttributes, memo } from "react";
import classNames from "classnames";
import { BackgroundCircle, BackgroundDots, BackgroundGrid } from "./icons";

import styles from "./styles.module.scss";

export type  ModalIconBackgroundType = "circle" | "grid" | "dots";

export type ModalIconBackgroundProps = HTMLAttributes<HTMLDivElement> & {
  type?: ModalIconBackgroundType
}

export const ModalIconBackground = memo<ModalIconBackgroundProps>((
  {
    type,
    children,
    className,
    ...props
  }) => {

  const renderIcon = () => {
    switch (type) {
      case "circle": return BackgroundCircle;
      case "dots": return BackgroundDots;
      case "grid": return BackgroundGrid;
    }
  }

  return (
    <div
      {...props}
      className={classNames(className, styles.root)}
    >
      {children}
      {type &&
        createElement(
          renderIcon(),
          {
            className: styles.background,
          },
        )
      }
    </div>
  );
});
